import React from 'react';
import { Navigate } from 'react-router-dom';

import { Application } from '@/types/api.ts';

const WorkableApplicationStepGuard = ({
  application,
  children
}: { application: Application; children: React.ReactNode }) => {
  if (application.status === 'completed') return <Navigate to="../complete" />;

  if (application.status !== 'worked_by_applicant') return <Navigate to="../end" />;

  return children;
};

export { WorkableApplicationStepGuard };
